import gql from 'graphql-tag';

import tokenFragment from '../fragments/tokenFragment';

export const mutationCreateTokenProviderAccessToken = gql`
  mutation createTokenProviderAccessToken(
    $accountID: DokkioID!
    $provider: CreateTokenOAuthProvider!
    $providerAccessToken: String!
    $providerAccessTokenVerificationHash: String!
  ) {
    createTokenProviderAccessToken(
      accountID: $accountID
      provider: $provider
      providerAccessToken: $providerAccessToken
      providerAccessTokenVerificationHash: $providerAccessTokenVerificationHash
    ) {
      ...tokenFragment
    }
  }
  ${tokenFragment}
`;

export default mutationCreateTokenProviderAccessToken;
